var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 103,
    viewBox: "0 0 123 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121.666 37.4273V64.9627L61.2915 101.709V74.1736L121.666 37.4273Z",
    fill: "#0099FF",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.921387 37.4272L0.921387 64.9625L61.2912 101.709V74.1734L0.921387 37.4272Z",
    fill: "#00DFB7",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M121.665 37.427L61.2912 0.680664L0.921387 37.427L61.2912 74.1733L121.665 37.427Z",
    fill: "#FFF4E9",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M114.701 66.6317L116.729 65.3888V43.7018L114.701 44.9401V66.6317Z",
    fill: "#0045D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M110.363 69.2016L112.391 67.9586V46.2717L110.363 47.51V69.2016Z",
    fill: "#0045D9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M106.025 71.716L108.053 70.4776V48.786L106.025 50.029V71.716Z",
    fill: "#0045D9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4567 82.3346L18.2075 59.1032V56.1674L56.4567 79.4035V82.3346Z",
    fill: "#0045D9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4569 90.6457L18.2078 67.4143V64.4785L56.4569 87.7145V90.6457Z",
    fill: "#0045D9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6375 57.2785C16.0995 57.0689 16.1905 56.2047 15.8408 55.3483C15.4911 54.4919 14.8331 53.9676 14.3712 54.1773C13.9092 54.3869 13.8182 55.2511 14.1678 56.1075C14.5175 56.9639 15.1755 57.4882 15.6375 57.2785Z",
    fill: "#0045D9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5347 54.7924C11.9967 54.5828 12.0877 53.7186 11.738 52.8622C11.3883 52.0058 10.7304 51.4815 10.2684 51.6911C9.8064 51.9008 9.71537 52.765 10.0651 53.6214C10.4148 54.4778 11.0727 55.002 11.5347 54.7924Z",
    fill: "#0045D9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6346 65.6186C16.0966 65.409 16.1876 64.5448 15.8379 63.6884C15.4882 62.832 14.8302 62.3077 14.3682 62.5173C13.9062 62.727 13.8152 63.5912 14.1649 64.4476C14.5146 65.304 15.1726 65.8283 15.6346 65.6186Z",
    fill: "#0045D9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5359 63.1397C11.9979 62.9301 12.089 62.0659 11.7393 61.2095C11.3896 60.3531 10.7316 59.8288 10.2696 60.0384C9.80762 60.2481 9.71659 61.1122 10.0663 61.9686C10.416 62.825 11.074 63.3493 11.5359 63.1397Z",
    fill: "#0045D9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43463 52.3095C7.89661 52.0998 7.98763 51.2356 7.63794 50.3792C7.28825 49.5228 6.63026 48.9985 6.16828 49.2082C5.7063 49.4178 5.61527 50.282 5.96496 51.1384C6.31465 51.9948 6.97265 52.5191 7.43463 52.3095Z",
    fill: "#0045D9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43585 60.6535C7.89783 60.4439 7.98886 59.5797 7.63917 58.7233C7.28947 57.8669 6.63148 57.3426 6.1695 57.5523C5.70752 57.7619 5.61649 58.6261 5.96619 59.4825C6.31588 60.3389 6.97387 60.8632 7.43585 60.6535Z",
    fill: "#0045D9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8805 33.5895C42.6684 34.0115 43.5396 34.2314 44.4234 34.2314C45.3071 34.2314 46.1784 34.0115 46.9663 33.5895C48.3653 32.7361 48.3565 31.354 46.9663 30.496C46.1781 30.075 45.3069 29.8557 44.4234 29.8557C43.5398 29.8557 42.6687 30.075 41.8805 30.496C40.4638 31.3447 40.4726 32.7314 41.8805 33.5895Z",
    fill: "#095DE8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4805 31.9617C51.0907 31.7441 50.7718 31.408 50.5654 30.997C50.0507 29.856 51.1638 28.678 53.0379 28.3812L69.1621 25.784C71.0407 25.4825 72.972 26.1643 73.4824 27.3052C73.9927 28.4461 72.884 29.6242 71.0098 29.9256L54.8901 32.5229C53.7255 32.7252 52.5299 32.5268 51.4805 31.957V31.9617Z",
    fill: "#095DE8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9361 38.492C49.5462 38.2745 49.2273 37.9384 49.0209 37.5274C48.5106 36.3864 49.6193 35.2084 51.4935 34.9116L77.3185 30.7374C79.197 30.436 81.1284 31.1224 81.6388 32.2633C82.1491 33.4042 81.0404 34.5823 79.1663 34.8791L53.3457 39.0532C52.1815 39.2594 50.9852 39.0625 49.9361 38.492Z",
    fill: "#077EDB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3638 48.4912C67.1517 48.9132 68.023 49.1331 68.9068 49.1331C69.7905 49.1331 70.6618 48.9132 71.4497 48.4912C72.8487 47.6424 72.8399 46.2557 71.4497 45.3977C70.6618 44.9757 69.7905 44.7557 68.9068 44.7557C68.023 44.7557 67.1517 44.9757 66.3638 45.3977C64.9692 46.2464 64.9692 47.6332 66.3638 48.4912Z",
    fill: "#00CBA9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0974 43.4593C57.7075 43.2418 57.3887 42.9056 57.1823 42.4946C56.672 41.3537 57.7806 40.1757 59.6592 39.8788L75.7746 37.2816C77.6531 36.9801 79.5845 37.6619 80.0949 38.8075C80.6052 39.953 79.4965 41.1264 77.6223 41.4233L61.5026 44.0205C60.3394 44.2255 59.1444 44.027 58.0974 43.4547V43.4593Z",
    fill: "#04A9CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginLogo);
export default __webpack_public_path__ + "static/media/loginLogo.8b4ae0288c1f7abd90fc86680e1de756.svg";
export { ForwardRef as ReactComponent };